import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { IconButton } from '@americanexpress/dls-react';
import { IconClose } from '@americanexpress/dls-icons';
import { setTravelCreditTabClosed } from '../../ducks/homeDuck';

const TravelCreditTabClose = () => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();

  return (
    <div className="flex border-lr-sm-down">
      <div className="margin-auto-l">
        <IconButton
          id="closeTravelCreditTabButton"
          shape="square"
          variant="tertiary"
          tertiaryColor="gray"
          aria-label={formatMessage({ id: 'travelCreditTab.button.close' })}
          onClick={() => dispatch(setTravelCreditTabClosed)}
          reactlytics={{
            element: 'hp-travelCreditTab',
            detail: 'showTravelCreditClose',
          }}
        >
          <IconClose size="md" />
        </IconButton>
      </div>
    </div>
  );
};

export default TravelCreditTabClose;
